export default "__VITE_ASSET__BSMU$3X___"